module.exports = __webpack_public_path__ + "static/media/home_pic.a3e643c2.png";